// extracted by mini-css-extract-plugin
export var table = "_to-0";